import React from 'react';
// Import the progress bar component
import { Container, Row, Col, Button, Form } from 'react-bootstrap';



const Step2 = () => {

    return (
        <>
            <Form>
                <Form.Group controlId="blockchain">
                    <Form.Label>Blockchain Network</Form.Label>
                    <Form.Select required>
                        <option value="">Select Network</option>
                        <option value="ethereum">Ethereum</option>
                        <option value="bsc">BNB Chain</option>
                    </Form.Select>
                </Form.Group>

                <Form.Group controlId="tokenAddress" className="mt-3">
                    <Form.Label>Token Smart Contract Address</Form.Label>
                    <Form.Control type="text" placeholder="0x..." required />
                </Form.Group>

                <Row className="mt-3">
                    <Col md={6}>
                        <Form.Group controlId="tokenName">
                            <Form.Label>Token Name</Form.Label>
                            <Form.Control type="text" placeholder="MyToken" required />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group controlId="tokenSymbol">
                            <Form.Label>Token Symbol (Ticker)</Form.Label>
                            <Form.Control type="text" placeholder="MTK" required />
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="mt-3">
                    <Col md={6}>
                        <Form.Group controlId="tokenDecimals">
                            <Form.Label>Token Decimals</Form.Label>
                            <Form.Control type="number" placeholder="18" required />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group controlId="tokenSupply">
                            <Form.Label>Total Supply</Form.Label>
                            <Form.Control type="number" placeholder="1000000" required />
                        </Form.Group>
                    </Col>
                </Row>

                <hr className="my-4" />

                <Form.Group controlId="twitter">
                    <Form.Label>Twitter URL</Form.Label>
                    <Form.Control type="url" placeholder="https://twitter.com/mytoken" />
                </Form.Group>

                <Form.Group controlId="telegram" className="mt-3">
                    <Form.Label>Telegram URL</Form.Label>
                    <Form.Control type="url" placeholder="https://t.me/mytoken" />
                </Form.Group>

                <Form.Group controlId="discord" className="mt-3">
                    <Form.Label>Discord URL</Form.Label>
                    <Form.Control type="url" placeholder="https://discord.gg/mytoken" />
                </Form.Group>

                <Form.Group controlId="whitepaper" className="mt-3">
                    <Form.Label>Whitepaper URL</Form.Label>
                    <Form.Control type="url" placeholder="https://mytoken.io/whitepaper.pdf" />
                </Form.Group>
            </Form>
        </>
    );
};

export default Step2;
